module.exports = __webpack_public_path__ + "images/fa-cfa-2-hero-mobile.webp";